export default __webpack_public_path__ + "static/media/Container_sq.6f618964.jpg";